import { PUBLIC_RECAPTCHA_ENABLE, PUBLIC_RECAPTCHA_SITE_KEY } from '$env/static/public';

export class RecaptchaV3Client {
  private static siteKey: string = PUBLIC_RECAPTCHA_SITE_KEY;
  private static enabled: boolean = PUBLIC_RECAPTCHA_ENABLE === 'true';
  private static script: HTMLScriptElement | null = null;

  constructor() {}

  public static initScript() {
    if (RecaptchaV3Client.script || !RecaptchaV3Client.enabled) return;

    RecaptchaV3Client.script = document.createElement('script');
    RecaptchaV3Client.script.src = `https://www.google.com/recaptcha/api.js?render=${RecaptchaV3Client.siteKey}`;
    RecaptchaV3Client.script.async = true;
    document.body.appendChild(RecaptchaV3Client.script);
  }

  public static async execute(action: string): Promise<string | undefined> {
    if (!RecaptchaV3Client.enabled) {
      return undefined;
    }

    if (!RecaptchaV3Client.script) {
      RecaptchaV3Client.initScript();
    }

    if (typeof window.grecaptcha === 'undefined') {
      return undefined;
    }
    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(RecaptchaV3Client.siteKey, { action });
          resolve(token);
        } catch (error) {
          reject(error);
        }
      });
    });
  }

  public static getSiteKey() {
    return RecaptchaV3Client.siteKey;
  }

  public static isEnabled() {
    return RecaptchaV3Client.enabled;
  }
}
